/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { MdOutlineModeEdit, MdOutlineLock } from 'react-icons/md';
import { PropTypes } from 'prop-types';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';

function Staff({ staff, onEdit, onChangePassword }) {
  return (
    <div className="staff-list-item d-flex mb-3">
      <div>
        <div className="d-flex flex-column">
          <span className="fw-500">
            {`${staff.Salutation}. ${staff.FirstName} ${staff.LastName}`}(
            {staff.AgentId}){' '}
            <span
              className={`badge ${
                staff.Status === 'active' ? 'purple-color' : 'primary-color'
              } staff-status`}
            >
              {staff.Status}
            </span>
          </span>
          <span className="secondary-text">{staff.ContactEmail}</span>
        </div>
      </div>
      <div className="d-flex">
        <AppIconButton
          variant="secondary"
          className="me-2"
          onClick={() => onChangePassword(staff)}
        >
          <MdOutlineLock className="edit-icon" />
        </AppIconButton>
        <AppIconButton
          onClick={() => onEdit(staff)}
          variant="secondary"
          className="me-2"
        >
          <MdOutlineModeEdit className="edit-icon" />
        </AppIconButton>
      </div>
    </div>
  );
}

Staff.propTypes = {
  staff: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func.isRequired,
};

export default Staff;
